import { Box, Divider, FormLabel } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { ContractDurationField } from "./ContractDurationField";
import { ContractOptionsField } from "./ContractOptionsField";
import { FrameworkAgreementField } from "./FrameworkAgreementField";

interface Props {
  eventId: string;
}

export const ContractPeriodSection = ({ eventId }: Props) => {
  const { t } = useTranslation();

  return (
    <Box borderWidth="1px" borderRadius="lg" p="5" mb="8">
      <FormLabel fontWeight="bold" fontSize="md" mb="4">{t("Contract period")}</FormLabel>
      <ContractDurationField eventId={eventId} />
      <Divider my="4" />
      <ContractOptionsField eventId={eventId} />
      <Divider my="4" />
      <FrameworkAgreementField eventId={eventId} />
    </Box>
  );
};
